module.exports = [
  "Garage Stellplatz",
  "Carport",
  "Duplex",
  "Garage",
  "Parkhausstellplatz",
  "Stellplatz",
  "Tiefgaragenstellplatz",
  "Garage/Sonstige",
  "Parken",
];



// WEBPACK FOOTER //
// ./src/data/parking.js